<template>
  <div>
    <base-header type="gradient-default" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você pode visualizar a equipe selecionada, além das tarefas
              que já foram submetidas para avaliação.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row mb-4">
        <div class="col-12">
          <team-card :tasks="openTasks" :members="members" :team="team" />
        </div>
      </div>
      <div class="row mb-6">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3
                    class="
                      mb-0
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                  >
                    <div>Tarefas</div>
                  </h3>
                </div>
                <div class="col-12">
                  <task-list-equipe
                    :data="openTasks"
                    icon="fas fa-eye"
                    title="Ativas"
                    emptyMessage="Não há tarefas ativas no momento"
                  />
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api.js";

import TeamCard from "@/components/TeamCard";
import TaskListEquipe from "../../../components/TaskListEquipe.vue";

export default {
  name: "submission",
  components: {
    TeamCard,
    TaskListEquipe
  },
  data() {
    return {
      model: {
        status: "",
        date: ""
      },
      openTasks: [],
      members: [],
      team: {},
      error: ""
    };
  },

  async mounted() {
    await this.loadTeam();
    this.tasksLoaded = true;
  },
  methods: {
    async loadTeam() {
      const loader = this.$loading.show({
        container: this.$refs.teamCard,
        width: 90,
        height: 90
      });
      try {
        const {
          data: { members, tasks, team }
        } = await api.get(
          `/company/challenges/${this.$route.params.id}/teams/${this.$route.params.teamId}`
        );
        if (tasks) this.openTasks = tasks;
        if (members) this.members = members;
        if (team) this.team = team;
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar as tarefas ativas`);
      }
    },
    async loadTasks() {
      const loader = this.$loading.show({
        container: this.$refs.list_open_tasks,
        width: 90,
        height: 90
      });
      try {
        const { data } = await api.get(
          `/company/challenges/${this.$route.params.id}/tasks`
        );
        if (data) this.openTasks = data;
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar as tarefas ativas`);
      }
    }
  },
  computed: {}
};
</script>
